<nav class="navbar bg-primary navbar-dark navbar-expand-lg d-none d-lg-flex">
  <a class="navbar-brand py-0" [routerLink]="['/']" routerLinkActive="router-link-active">
    <img class="ms-1 h-100" [src]="'images/home-logo.png' | contentAssetImage" draggable="false" />
  </a>

  <button
    class="navbar-toggler"
    type="button"
    (click)="isCollapsed = !isCollapsed"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <!-- Left Side Content -->
  <div class="navbar-collapse" [ngbCollapse]="isCollapsed" id="navbarSupportedContent">
    <div class="nav-container">
      <ul class="navbar-nav me-auto" #greedyNav>
        <li class="nav-item active">
          <a class="nav-link mx-1" [routerLink]="['/rewards']" routerLinkActive="router-link-active">{{
            'nav.rewards' | translate
          }}</a>
        </li>
        <li class="nav-item active">
          <a class="nav-link mx-1" [routerLink]="['/challenges']" routerLinkActive="router-link-active">{{
            'nav.challenges' | translate
          }}</a>
        </li>
        <li class="nav-item active">
          <a class="nav-link mx-1" [routerLink]="['/earn']" routerLinkActive="router-link-active">{{ 'nav.earn' | translate }}</a>
        </li>
        <li class="nav-item active">
          <a class="nav-link mx-1" [routerLink]="['/ecash']" routerLinkActive="router-link-active">{{
            'nav.ecash' | translate
          }}</a>
        </li>
      </ul>
    </div>
    <!-- Right Side Content -->
    <div class="d-flex align-items-center flex-nowrap my-2 my-lg-0">
      <div [routerLink]="['/activity']" class="balance font-size-14 text-primary cursor-pointer me-2">
        <div *ngIf="loyaltyPointsCard$" class="text-white d-flex align-items-center justify-content-center">
          <span class="material-icons font-size-20 pe-2">loyalty</span>
          <span class="fw-bold points"
            >{{ loyaltyPointsCard$ | async | number: '1.0-0' }} {{ 'fgbcl.curreuncy.pts' | translate }}</span
          >
        </div>
      </div>

      <div [routerLink]="['/ecash']" class="balance font-size-14 text-primary cursor-pointer">
        <div *ngIf="combinedCard$" class="text-white d-flex align-items-center justify-content-center">
          <span class="material-symbols-outlined font-size-20 pe-2"> money_bag </span>
          <span class="fw-bold points">{{ combinedCard$ | async | FortressCurrencyPipe }}</span>
        </div>
      </div>

      <div class="notification-button-wrapper">
        <fgb-notification-button />
      </div>

      <div class="member" ngbDropdown #ddAccount="ngbDropdown" [autoClose]="'outside'">
        <button
          class="nav-link btn text-white d-flex align-items-center ms-2 me-3 px-0 justify-content-end"
          id="namedropdown"
          ngbDropdownToggle
          (click)="isCollapsed = !isCollapsed"
        >
          <span class="material-icons-outlined"> dehaze </span>
        </button>
      </div>
    </div>
  </div>
</nav>

<ng-template #memberDetailsLoading>
  <div class="user-box d-block text-center text-on-primary px-4">
    <fgb-loading [size]="'small'"></fgb-loading>
  </div>
</ng-template>

<ng-container *ngIf="!isCollapsed">
  <div class="grey-background">
    <div class="d-flex flex-column mobile-nav-menu-content">
      <!-- Close Button -->
      <button class="close-button position-absolute border-0 p-0 bg-white" (click)="isCollapsed = !isCollapsed">
        <i class="material-icons">close</i>
      </button>

      <!-- Club Logo -->
      <div class="d-flex align-items-center justify-content-start brand-logo">
        <img class="brand" [src]="'images/logo.png' | contentAssetImage" draggable="false" />
      </div>

      <!-- Member Info -->
      <div class="modal-content d-flex gap-2 rounded-0 text-black" aria-live="polite">
        <div class="modal-header w-100 d-flex align-items-center justify-content-between">
          <div class="member-card bg-primary text-white rounded">
            <div>
              <div
                class="card-name fw-bold text-uppercase font-size-18 font-page-heading"
                *ngIf="memberDetails$ | async as memberDetails"
              >
                {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
              </div>
              <div class="account-num-header font-size-14 d-flex flex-row align-items-center" *ngIf="card$ | async as memberCard">
                <span class="font-size-14">{{ 'barcode.memberid' | translate }} </span>
                <span class="font-size-14">{{ memberCard.ExternalRefNumber }}</span>
              </div>
            </div>
            <div class="w-100">
              <div class="add-card mb-4 mt-3">
                <fgb-add-card-payment (onClickNavigate)="isCollapsed = !isCollapsed" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Nav Links -->
      <ul class="right-nav-menu-list mt-3" role="menubar" aria-label="Side navigation links">
        <li role="none">
          <a
            class="right-nav-menu-item text-black"
            [routerLink]="['/']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
            role="menuitem"
            (click)="isCollapsed = true"
          >
            <div class="nav-text">
              <span class="icon material-icons" aria-hidden="true">home</span>{{ 'nav.home' | translate }}
            </div>
          </a>
        </li>
        <li role="none">
          <a
            class="right-nav-menu-item text-black"
            [routerLink]="['/account']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
            role="menuitem"
            (click)="isCollapsed = true"
          >
            <div class="nav-text">
              <span class="icon material-icons" aria-hidden="true">account_circle</span>{{ 'nav.account' | translate }}
            </div>
          </a>
        </li>
        <li role="none">
          <a
            class="right-nav-menu-item text-black"
            [routerLink]="['/rewards']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
            role="menuitem"
            (click)="isCollapsed = true"
          >
            <div class="nav-text">
              <span class="icon material-icons" aria-hidden="true">card_giftcard</span>{{ 'nav.rewards' | translate }}
            </div>
          </a>
        </li>
        <li role="none">
          <a
            class="right-nav-menu-item text-black"
            [routerLink]="['/challenges']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
            role="menuitem"
            (click)="isCollapsed = true"
          >
            <div class="nav-text">
              <span class="icon material-icons" aria-hidden="true">emoji_events</span>{{ 'nav.challenges' | translate }}
            </div>
          </a>
        </li>
        <li role="none">
          <a
            class="right-nav-menu-item text-black"
            [routerLink]="['/rewards/wallet']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
            role="menuitem"
            (click)="isCollapsed = true"
          >
            <div class="nav-text">
              <span class="icon material-icons" aria-hidden="true">wallet</span>{{ 'nav.wallet' | translate }}
            </div>
          </a>
        </li>
        <li role="none">
          <a
            class="right-nav-menu-item text-black"
            [routerLink]="['/earn']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
            role="menuitem"
            (click)="isCollapsed = true"
          >
            <div class="nav-text">
              <span class="icon material-icons" aria-hidden="true">star</span>{{ 'nav.earn' | translate }}
            </div>
          </a>
        </li>
        <li role="none">
          <button
            class="right-nav-menu-item right-nav-menu-group text-black w-100 text-start border-0 bg-transparent"
            (click)="isHelpOpen = !isHelpOpen"
            [attr.aria-expanded]="isHelpOpen"
            aria-controls="helpSubmenu"
            attr.aria-label="{{ isHelpOpen ? 'Collapse help menu' : 'Expand help menu' }}"
            role="menuitem"
            aria-haspopup="true"
          >
            <div class="d-flex align-items-center justify-content-between">
              <div class="nav-text">
                <span class="icon material-icons" aria-hidden="true">info</span>

                <div class="content">
                  <div class="nav-text">{{ 'nav.help' | translate }}</div>
                </div>
              </div>
              <span class="material-icons accordion-chevron" [class.open]="isHelpOpen" aria-hidden="true">{{
                isHelpOpen ? 'chevron_right' : 'expand_less'
              }}</span>
            </div>
          </button>

          <ul id="helpSubmenu" class="help-submenu list-unstyled" *ngIf="!isHelpOpen" role="menu" aria-label="Help sub-menu">
            <li role="none">
              <a
                class="right-nav-menu-subitem text-black"
                [routerLink]="['/terms']"
                [routerLinkActive]="'active'"
                [routerLinkActiveOptions]="{ exact: true }"
                role="menuitem"
                (click)="isCollapsed = true"
                attr.aria-label="{{ 'nav.terms.screenreader' | translate: { fgbdefault: 'Move to terms page' } }}"
              >
                <div class="nav-text">{{ 'nav.terms' | translate }}</div>
              </a>
            </li>
            <li role="none">
              <a
                class="right-nav-menu-subitem text-black"
                [routerLink]="['/faq']"
                [routerLinkActive]="'active'"
                [routerLinkActiveOptions]="{ exact: true }"
                role="menuitem"
                (click)="isCollapsed = true"
                attr.aria-label="{{ 'nav.faq.screenreader' | translate: { fgbdefault: 'Move to FAQ page' } }}"
              >
                <div class="nav-text">{{ 'nav.faq' | translate }}</div>
              </a>
            </li>
            <li role="none">
              <a
                class="right-nav-menu-subitem text-black"
                [routerLink]="['/contact']"
                [routerLinkActive]="'active'"
                [routerLinkActiveOptions]="{ exact: true }"
                role="menuitem"
                (click)="isCollapsed = true"
                attr.aria-label="{{ 'nav.contact.us.screenreader' | translate: { fgbdefault: 'Move to contact us page' } }}"
              >
                <div class="nav-text">{{ 'nav.contact.us' | translate }}</div>
              </a>
            </li>
          </ul>
        </li>
      </ul>
      <div class="mobile-nav-button-container">
        <!-- Nav Buttons -->
        <!-- Help Group -->

        <a class="log-out" (click)="logout()">
          <i class="material-icons font-size-14 fw-bold">logout</i>
          <div class="nav-text fw-bold">{{ 'nav.log.out' | translate }}</div>
        </a>
      </div>
    </div>
  </div>
</ng-container>
